// @ts-nocheck
import { Button, Typography } from "@insite/mobius/index";
import { CustomWidgetModule } from "@store/Framework/Types/types";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import { TabDefinition } from "@insite/client-framework/Types/TabDefinition";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import useSignatureData from "@store/Framework/Common/Hooks/useSignatureData";
import SigningModal from "@store/Library/Components/Signature/SigningModal";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import SignatureIcon from "@store/Library/Widgets/SignatureIntegration/SignatureIcon";
import * as cssLinter from "css";
import React, { useMemo } from "react";
import styled, { createGlobalStyle, css } from "styled-components";

const StyledButton = styled(Button)`
    display: flex;
    column-gap: 0.5rem;
    margin-block: 1rem;
`;

const defaultCustomCss = `& {
}

.signature-pad-trigger {
}

.signature-pad-trigger-text {
}

.signature-pad-warning {
}


.signature-modal-title {
}


.signature-editable-canvas {
}

.signature-editable-name-field {
}

.signature-editable-email-container {
}

.signature-editable-button-row {
}

.signature-editable-clear-button {
}

.signature-editable-save-button {
}

.signature-receipt-container {
}

.signature-receipt-title {
}

.signature-receipt-image {
}

.signature-receipt-date {
}

.signature-receipt-close-button {
}

.signature-editable-declaration {
}

.signature-editable-declaration-text {
}

.signature-editable-declaration-title-text {
}

.signature-editable-email-checkbox {
}

.signature-editable-email-input {
}
`;
const SignatureGlobalStyle = createGlobalStyle<{ css: string }>`
  ${props => props.css}
`;
enum fields {
    editable = "editable",
    customCSS = "customCSS",
}

interface SignatureButtonProps extends WidgetProps {
    fields: {
        [fields.editable]: boolean;
        [fields.customCSS]: string;
    };
}
const SignatureIntegration: React.FC<SignatureButtonProps> = ({ fields }) => {
    const { editable, customCSS } = fields;
    const [showModal, setShowModal] = React.useState(false);
    const { signatureData, setSignature } = useSignatureData();
    const showButton = editable || signatureData.customerName;
    return (
        <>
            <SignatureGlobalStyle css={customCSS} />
            {showButton && (
                <StyledButton sizeVariant="medium" onClick={() => setShowModal(true)} className="signature-pad-trigger">
                    <SignatureIcon />
                    <Typography className="signature-pad-trigger-text">
                        {translate("Confirmation Of Receipt")}
                    </Typography>
                </StyledButton>
            )}
            {!showButton && (
                <InfosBox type="warning" className="signature-pad-warning">
                    {siteMessage("SignaturePad_NotSigned")}
                </InfosBox>
            )}
            <SigningModal
                onClose={() => setShowModal(false)}
                setSignatureState={setSignature}
                signatureData={signatureData}
                editable={editable}
                isOpen={showModal}
            />
        </>
    );
};

const advancedTab: TabDefinition = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: CustomWidgetModule = {
    component: SignatureIntegration,
    definition: {
        group: "SignaturePad",
        displayName: "SignaturePad",
        fieldDefinitions: [
            {
                name: fields.editable,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                displayName: "Editable",
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (!value) return "";
                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }
                    return "Unable to parse CSS";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
